import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black-950 py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0}}
          whileInView={{opacity: 1}}
          viewport={{once: true}}
          className="flex flex-col md:flex-row justify-between items-center"
        >
          <div className="flex items-center space-x-3 mb-6 md:mb-0">
            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
              <span className="text-black-900 font-bold text-lg">K</span>
            </div>
            <span className="font-semibold text-white text-xl">itskaivalya.com</span>
          </div>
          <div className="text-center md:text-right">
            <p className="text-black-400">
              © 2025 Maitreya Labs. We help you fix what matters first.
            </p>
          </div>
        </motion.div>

        {/* Footer Links */}
        <div className="mt-6 flex flex-wrap justify-center gap-4 md:gap-6">
          <Link to="/courses" className="text-black-400 hover:text-white transition-colors">
            Courses
          </Link>
          <Link to="/privacy-policy" className="text-black-400 hover:text-white transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms-and-conditions" className="text-black-400 hover:text-white transition-colors">
            Terms and Conditions
          </Link>
          <Link to="/refund-policy" className="text-black-400 hover:text-white transition-colors">
            Refund Policy
          </Link>
          <Link to="/disclaimer" className="text-black-400 hover:text-white transition-colors">
            Disclaimer
          </Link>
          <Link to="/cookie-policy" className="text-black-400 hover:text-white transition-colors">
            Cookie Policy
          </Link>
        </div>

        {/* Disclaimer text with very small font */}
        <div className="mt-8 text-center">
          <p className="text-[8px] text-black-600">
            This site is not a part of the Facebook™ website or Facebook™ Inc. This site is NOT endorsed by Facebook™ in any way. FACEBOOK™ is a trademark of FACEBOOK™, Inc. Maitreya Labs can not and does not make any guarantees about your ability to get results or earn any money with our ideas, information, tools, or strategies. What we can guarantee is your satisfaction with our training. We give you a 60-day 100% satisfaction guarantee on the products we sell, so if you are not happy for any reason with the quality of our training, just ask for your money back. You should know that all products and services by our company are for educational and informational purposes only. Nothing on this page, any of our websites, or any of our content or curriculum is a promise or guarantee of results or future earnings, and we do not offer any legal, medical, tax or other professional advice. Any financial numbers referenced here, or on any of our sites, are illustrative of concepts only and should not be considered average earnings, exact earnings, or promises for actual or future performance. Use caution and always consult your accountant, lawyer or professional advisor before acting on this or any information related to a lifestyle change or your business or finances. You alone are responsible and accountable for your decisions, actions and results in life, and by your registration here you agree not to attempt to hold us liable for your decisions, actions or results, at any time, under any circumstance. We are not affiliated with or endorsed by Meta, Facebook, Instagram, Google, or YouTube. Results vary and depend on many factors outside our control. By using this site, you agree to our Terms and Privacy Policy.
            <br /><br />
            This brand is owned and operated by Maitreya Labs.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;